import React from 'react';
import useAuth from 'core/hooks/useAuth';
import AccessResourcesDenied from './AccessResourcesDenied';

const RestrictedAccessRole = ({ children, roles = [] }) => {
  const { hasRole } = useAuth();

  if (roles?.length === 0) {
    return null;
  }

  if (!hasRole(...roles)) {
    return (
      <AccessResourcesDenied
        title="Sem permissão"
        subTitle="Você não possui permissão para visualizar essa página."
      />
    );
  }

  return children;
};

export default RestrictedAccessRole;
